"use client";

import { useTranslations } from "next-intl";
import { useEffect, useRef, useState } from "react";
import { DietDetailsDrawer } from "@/features/diets/components/diet-details-drawer";
import type { CatalogListItemElements } from "@/features/diets/types";

type Props = {
  description: string;
  configParams?: Record<string, string | number | string[]>;
  dietId: string;
  elementsConfig: CatalogListItemElements;
};

export const DietListItemDescription = ({
  description,
  configParams,
  elementsConfig,
  dietId,
}: Props) => {
  const t = useTranslations("caterings");
  const descRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = descRef.current;
    if (!el) return;

    const observer = new ResizeObserver(() => {
      setIsTruncated(el.scrollHeight > el.clientHeight);
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="mt-3 mb-5 md:mb-3 xl:mb-5">
      <div className="relative">
        <div
          ref={descRef}
          className="line-clamp-2 text-sm"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {isTruncated && (
          <span className="absolute right-0 bottom-0 bg-white pl-1">
            <DietDetailsDrawer
              configuration={configParams}
              dietId={dietId}
              label={
                <span className="font-normal text-sm">
                  <span>...</span>{" "}
                  <span className="underline underline-offset-4">
                    {t("show_more")}
                  </span>
                </span>
              }
              showCta={elementsConfig.menuCta}
            />
          </span>
        )}
      </div>
    </div>
  );
};
